export const findCompletedAchievements = userAchievements =>
  !!userAchievements?.length
    ? userAchievements?.filter(ua => {
        // Find any achievements that have been completed.
        return !!ua.dateCompletedUTC && !ua.wasAcknowledged;
      })
    : [];
